import { UserCredential } from "firebase/auth";

import {
  getProviders,
} from "@/services/hoc/client.wrapper";

export async function login(token: string) {
  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`,
  };

  await fetch("/api/login", {
    method: "GET",
    headers,
  });
}

export async function loginWithCredential(credential: UserCredential) {
  const idToken = await credential.user.getIdToken(true);
  getProviders();
  await login(idToken);
}

export async function logout() {
  const headers: Record<string, string> = {};

  await fetch("/api/logout", {
    method: "GET",
    headers,
  });
}

export async function refreshToken() {
  const headers: Record<string, string> = {};
  getProviders();
  await fetch("/api/refresh-token", {
    method: "GET",
    headers,
  });
}
